import { UserColumns, UserData, userEntityName } from '@/backend/features/authentication/shared';
import { useTranslation } from '@/ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import { Row } from '@juvare/platform-shared/features/storage';
import React from 'react';

export function useHandleRemoveUser(row: Row<UserColumns>, reload: () => void) {
    const { t } = useTranslation();
    const userStorage = useStorageClient<UserData, UserColumns>(userEntityName);
    return React.useCallback(() => {
        showFormDialog({
            title: t('removeUser', { name: row.columns.email }),
            config: {
                type: 'form',
                children: [
                    {
                        type: 'form.content',
                        text: t('removeUserMessage'),
                    },
                ],
            },
            data: row.columns,
            onSubmit: () => {
                return userStorage
                    .post({ action: 'delete', id: row.id })
                    .then(() => reload())
                    .catch((error) => {
                        handleErrorDialog(error);
                        throw error;
                    });
            },
            submitLabel: t('remove'),
        });
    }, [row, reload, t, userStorage]);
}
